export default __webpack_public_path__ + "static/media/copy-blue.6d9f71a5.svg";